export default "__VITE_ASSET__52056c92__"